import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  cancelBtn: {
    backgroundColor: "#ececec",
    fontSize:15
  },
  okBtn: {
    fontSize:15
  },

  dialogActions: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 25,
    paddingRight: 25
  }
});

const SignOutUserDialog = ({ isDialogOpen, onCancel, onClickFunc, popupMessage }: any) => {
  const classes = useStyles();
  return (
    <Dialog open={isDialogOpen} onClose={() => onCancel(false)} fullWidth={true} maxWidth="xs">
      <DialogTitle><Typography>{popupMessage}</Typography></DialogTitle>
      <DialogActions className={classes.dialogActions}  >
        <Button onClick={() => onCancel(false)} className={classes.cancelBtn}>
          Cancel
        </Button>
        <Button onClick={onClickFunc} className={classes.okBtn} color="primary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignOutUserDialog;
